/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Review } from './Review';
import {
    ReviewFromJSON,
    ReviewFromJSONTyped,
    ReviewToJSON,
} from './Review';

/**
 * 
 * @export
 * @interface CreateReview200ResponseAllOfData
 */
export interface CreateReview200ResponseAllOfData {
    /**
     * 
     * @type {Review}
     * @memberof CreateReview200ResponseAllOfData
     */
    review: Review;
}

/**
 * Check if a given object implements the CreateReview200ResponseAllOfData interface.
 */
export function instanceOfCreateReview200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "review" in value;

    return isInstance;
}

export function CreateReview200ResponseAllOfDataFromJSON(json: any): CreateReview200ResponseAllOfData {
    return CreateReview200ResponseAllOfDataFromJSONTyped(json, false);
}

export function CreateReview200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReview200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'review': ReviewFromJSON(json['review']),
    };
}

export function CreateReview200ResponseAllOfDataToJSON(value?: CreateReview200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'review': ReviewToJSON(value.review),
    };
}

